/* eslint-disable import/named */
import { fromJS } from 'immutable';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as types from '../../constants';

import * as Services from './service';

import * as ServicesApp from '../service';

const upsellPopupReducer = state => state.get('upsellPopupReducer');

export function* getProductsDetailSaga(actions) {
  const response = yield call(ServicesApp.getProductsDetailService, actions.ids);
  const products = response ? response.products : [];

  yield put({
    type: types.CHANGE_TARGET_PRODUCT_UPSELL_POPUP_RESULT,
    res: products
  });
}

export function* getCollectionDetailSaga(actions) {
  const response = yield call(ServicesApp.getCollectionDetailService, actions.ids);
  const collection = response || [];

  yield put({
    type: types.CHANGE_LIST_TARGET_POPUP_COLLECTION_RESULT,
    res: collection
  });
}

export function* getRecommendPopupProductDetailSaga(actions) {
  const response = yield call(ServicesApp.getProductsDetailService, actions.ids);
  const products = response ? response.products : [];

  yield put({
    type: types.CHANGE_LIST_RECOMMEND_POPUP_PRODUCT_RESULT,
    res: products
  });
}

export function* getRecommendPopupCollectionDetailSaga(actions) {
  const response = yield call(ServicesApp.getCollectionDetailService, actions.ids);
  const collection = response || [];

  yield put({
    type: types.CHANGE_LIST_RECOMMEND_POPUP_COLLECTION_RESULT,
    res: collection
  });
}

export function* getListUpsellPopupSaga() {
  const response = yield call(ServicesApp.getListUpsellCampaignService, 'popup');
  yield put({
    type: types.GET_LIST_UPSELL_POPUP_RESULT,
    res: response
  });
}

function* putUpsellFieldCampaignCommon(field, value) {
  yield put({
    type: types.CHANGE_UPSELL_POPUP_PRODUCT_DETAIL_FIELD,
    payload: { field, value }
  });
}

function* getDataProductsDetail(data) {
  // get target products detail campaign
  const targetType = data.target_type;
  if (targetType === 'products') {
    const response = yield call(ServicesApp.getProductsDetailService, JSON.parse(data.target_ids || '[]'));
    const products = response ? response.products : [];
    yield putUpsellFieldCampaignCommon('targetProductDetail', fromJS(products));
  } else {
    const response = yield call(ServicesApp.getCollectionDetailService, JSON.parse(data.target_ids || '[]'));
    const collection = response || [];
    yield putUpsellFieldCampaignCommon('targetCollectionDetail', fromJS(collection));
  }

  // upsell
  const recommendType = data.recommend_type;
  if (recommendType === 'products') {
    const response = yield call(ServicesApp.getProductsDetailService, JSON.parse(data.recommend_ids || '[]'));
    const products = response ? response.products : [];
    yield putUpsellFieldCampaignCommon('recommendProductDetail', fromJS(products));
  } else {
    const response = yield call(ServicesApp.getCollectionDetailService, JSON.parse(data.recommend_ids || '[]'));
    const collection = response || [];
    yield putUpsellFieldCampaignCommon('recommendCollectionDetail', fromJS(collection));
  }
}

function* getDetailUpsellPopupSaga(actions) {
  if (actions.id !== 'new') {
    const response = yield call(ServicesApp.getDetailCampaignUpsellService, actions.id);
    yield put({
      type: types.GET_DETAIL_CAMPAIGN_UPSELL_POPUP_RESULT,
      payload: { status: response && response.id > 0, data: response }
    });
    yield getDataProductsDetail(response);
  }
}

function* saveSettingUpSellPopupCampaignSaga() {
  const data = yield select(upsellPopupReducer);
  const result = yield call(ServicesApp.saveSettingUpSellCampaignService, data.get('upsellCampaign'));
  yield put({
    type: types.SAVE_SETTING_UPSELL_POPUP_CAMPAIGN_RESULT,
    res: result && result.success && result.id ? result.id : false
  });
}

function* changeStatusUpsellPopupSaga(action) {
  const result = yield call(ServicesApp.changeStatusCampaignUpsellService, action);
  yield put({
    type: types.CHANGE_STATUS_UPSELL_POPUP_RESULT,
    res: result && result.success,
    payload: action.payload
  });
}

function* deleteCampaignUpsellPopupSaga(action) {
  const result = yield call(ServicesApp.deleteCampaignUpsellV2Service, action);
  if (result && result.success) {
    yield getListUpsellPopupSaga();
  }
  yield put({
    type: types.DELETE_CAMPAIGN_UPSELL_POPUP_RESULT,
    res: result && result.success ? 1 : 2
  });
}

function* getProductsInCollectionSaga(payload) {
  const response = yield call(Services.getProductsInCollectionService, payload);
  if (response && response.products) {
    yield putUpsellFieldCampaignCommon('listProductsInCollection', fromJS(response.products));
  }
}

function* sagaActions() {
  yield takeEvery(types.CHANGE_TARGET_PRODUCT_UPSELL_POPUP, getProductsDetailSaga);
  yield takeEvery(types.CHANGE_LIST_TARGET_POPUP_COLLECTION, getCollectionDetailSaga);
  yield takeEvery(types.CHANGE_LIST_RECOMMEND_POPUP_PRODUCT, getRecommendPopupProductDetailSaga);
  yield takeEvery(types.CHANGE_LIST_RECOMMEND_POPUP_COLLECTION, getRecommendPopupCollectionDetailSaga);
  yield takeEvery(types.GET_LIST_UPSELL_POPUP, getListUpsellPopupSaga);
  yield takeEvery(types.GET_DETAIL_CAMPAIGN_UPSELL_POPUP, getDetailUpsellPopupSaga);
  yield takeEvery(types.SAVE_SETTING_UPSELL_POPUP_CAMPAIGN, saveSettingUpSellPopupCampaignSaga);
  yield takeEvery(types.CHANGE_STATUS_UPSELL_POPUP, changeStatusUpsellPopupSaga);
  yield takeEvery(types.DELETE_CAMPAIGN_UPSELL_POPUP, deleteCampaignUpsellPopupSaga);
  yield takeEvery(types.GET_PRODUCTS_IN_COLLECTION, getProductsInCollectionSaga);
}

export default sagaActions;
